module.exports = __webpack_public_path__ + "static/media/A208BEST.fc9a8fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/A208BEST.jpg
// module id = 215
// module chunks = 0